module.exports = __webpack_public_path__ + "static/media/printing-services-img18.04ea795a.jpg";